import axios from '../utils/axios';

export default function fetchReports(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/get-reports', { params })
    )
}
